import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Modal, Button, message } from "antd";
import Macbook from "./img/macbook_mockup.png";
import HomeHeader from "./Headesr";
import NewHomepageFooter from "./NewHomepageFooter";
import "./MarketingRebrand.css";

const benefitCards = [
  {
    icon: "✓",
    title: "Fraud detection",
    description:
      "AI-assisted checks flag document inconsistencies early so teams can review risk with more context.",
  },
  {
    icon: "↔",
    tone: "pink",
    title: "Overexposure signals",
    description:
      "See when borrowers are being assessed by multiple lenders so offers can be made with clearer risk awareness.",
  },
  {
    icon: "↗",
    tone: "green",
    title: "Diversified borrower flow",
    description:
      "Access a broader range of SME borrower profiles, products, and funding needs from a single lender console.",
  },
  {
    icon: "⚡",
    title: "Faster operations",
    description:
      "Reduce manual follow-ups with structured documents, borrower messaging, activity logs, and offer workflows.",
  },
  {
    icon: "◷",
    tone: "pink",
    title: "Better decision timing",
    description:
      "Prioritize requests by urgency, borrower readiness, product type, and latest activity.",
  },
  {
    icon: "◎",
    tone: "green",
    title: "Data-led strategy",
    description:
      "Use transaction insights, acceptance flows, and analytics to refine loan strategy over time.",
  },
];

const partnerPoints = [
  {
    icon: "1",
    tone: "green",
    title: "Diversified loan portfolio",
    description:
      "Reach a wider borrower pool across loan products and borrower profiles while keeping review standards consistent.",
  },
  {
    icon: "2",
    title: "Increased efficiency",
    description:
      "Reduce repetitive administration with structured applications, reusable documents, automated status visibility, and clearer handoffs.",
  },
  {
    icon: "3",
    tone: "pink",
    title: "Transparency and insights",
    description:
      "Use borrower activity, loan analytics, bank statement signals, and offer history to make decisions with more context.",
  },
];

const workflow = [
  ["1", "Create lender profile", "Set borrower-facing profile, response time, social links, and lender presentation blocks."],
  ["2", "Review borrower requests", "Use product filters, loan cards, borrower documents, and analytics to decide quickly."],
  ["3", "Submit offers", "Build terms, request documents, and message borrowers without leaving the lender workflow."],
  ["4", "Track accepted loans", "Monitor repayments, activity, and accepted loan status with the same visual system."],
];

const tourTabs = [
  ["overview", "1. Lender View"],
  ["commitments", "2. Commitments"],
  ["lumpSums", "3. Lump-sum Detection"],
  ["evidence", "4. Evidence & Drilldowns"],
  ["exposure", "5. Lender Exposure"],
  ["anomalies", "6. Anomaly Feed"],
  ["monthly", "7. Month-by-Month"],
];

const commitmentRows = [
  ["Payment Payment", "Consistent repeated debit cluster.", "Monthly", 47609, "3", "m", "Recurring debit"],
  ["Ct0034375535M001 Loan", "Recurring loan-style debit detected.", "Ad hoc", 30000, "1", "m", "Loan repayment"],
  ["Aug Payment", "", "Irregular", 17940, "5", "l", "Recurring debit"],
  ["Coll Nac Phy05 25 Htsg A C Starhill", "", "Irregular", 17709, "4", "m", "Recurring debit"],
  ["Othr Wongi Lin Lian Refund Loan Pyt", "", "Ad hoc", 9300, "1", "m", "Loan repayment"],
  ["Loan Payment Loan Payment", "", "Irregular", 7438, "6", "h", "Loan repayment"],
];

const lumpSumRows = [
  ["Dec 8, 2025", 595268, "DEC IBG GIRO OTHR Kris+ Pte Ltd", "inj", "Transfer / injection", "Transfer-style wording suggests internal movement.", false],
  ["Oct 28, 2025", 407774, "010444 CHEQUE DEPOSIT OCBC", "large", "Large credit", "Materially larger than usual incoming pattern.", true],
  ["May 22, 2025", 400000, "MAY LOAN TXN DISBURSEMENT", "loan", "Loan disbursement", "Financing proceeds, not operating revenue.", false],
  ["Sep 8, 2025", 330979, "OTHR Kris+ Pte Ltd", "large", "Large credit", "Reviewed as operating inflow.", true],
  ["Aug 8, 2025", 312721, "AUG IBG GIRO OTHR Kris+ Pte Ltd", "inj", "Transfer / injection", "Needs source confirmation.", false],
  ["Oct 21, 2025", 200000, "OTHR S$ REVAMP HAIR S PTE.", "round", "Round figure credit", "Round-number inflow needs review.", false],
];

const waterfallMonths = [
  ["Mar", "70%", "30%", "75%", "60%", "-746k", "neg"],
  ["Jul", "60%", "38%", "32%", "70%", "+94k", "pos"],
  ["Sep", "65%", "70%", "80%", "68%", "-227k", "neg"],
  ["Nov", "68%", "55%", "30%", "95%", "+453k", "pos"],
  ["Jan", "95%", "28%", "72%", "72%", "-725k", "neg"],
  ["May", "72%", "72%", "26%", "100%", "+761k", "pos"],
  ["Aug", "100%", "42%", "30%", "85%", "+201k", "pos"],
  ["Dec", "85%", "58%", "90%", "100%", "-490k", "neg"],
];

const exposureRows = [
  ["Ct0034375535M001 Loan", "SGD 30,000", "1", "SGD 660,000", "Loan-style debit detected."],
  ["Othr Wongi Lin Lian Refund Loan Pyt", "SGD 9,300", "1", "SGD 204,600", "Loan repayment wording."],
  ["Loan Payment Loan Payment", "SGD 7,438", "6", "SGD 163,644", "Recurring loan-style debit."],
];

const monthlyRows = [
  ["Mar 2025", "SGD 440,447", "SGD 1,187,348", "-SGD 746,901", "SGD 935,803", "SGD 921,018"],
  ["Jul 2025", "SGD 543,618", "SGD 449,338", "+SGD 94,280", "SGD 1,102,677", "SGD 908,987"],
  ["Sep 2025", "SGD 1,239,125", "SGD 1,466,901", "-SGD 227,777", "SGD 1,057,542", "SGD 556,998"],
  ["Nov 2025", "SGD 909,898", "SGD 456,088", "+SGD 453,810", "SGD 2,358,554", "SGD 1,992,464"],
  ["May 2026", "SGD 1,153,449", "SGD 392,170", "+SGD 761,279", "SGD 1,664,169", "SGD 851,586"],
];

const formatSgd = (value) =>
  `SGD ${Math.round(value).toLocaleString("en-SG")}`;

const MlAnalysisTour = () => {
  const [activeTour, setActiveTour] = useState("overview");
  const [amount, setAmount] = useState(0);
  const [tenor, setTenor] = useState(24);
  const [rate, setRate] = useState(2);
  const [keptCommitments, setKeptCommitments] = useState(
    commitmentRows.map(() => true),
  );

  const commitmentTotal = commitmentRows.reduce(
    (sum, row, index) => sum + (keptCommitments[index] ? row[3] : 0),
    0,
  );
  const principal = amount / Math.max(tenor, 1);
  const interest = amount * (rate / 100);
  const totalPayment = principal + interest;
  const liveDsr = Math.min(72, 24.9 + totalPayment / 10000);
  const liveFcc = Math.max(1.3, 8.78 - totalPayment / 60000);
  const adjustedRevenue = 6155216;

  const toggleCommitment = (index) => {
    setKeptCommitments((prev) =>
      prev.map((value, itemIndex) => (itemIndex === index ? !value : value)),
    );
  };

  const renderWaterfall = () => (
    <div className="ml-waterfall">
      {waterfallMonths.map(([month, opening, deposits, withdrawals, closing, net, status]) => (
        <div className="ml-wf-month" key={month}>
          <div className="ml-wf-m">{month}</div>
          <div className="ml-wf-bars">
            <div className="b" style={{ height: opening, background: "#cbd5e1" }} />
            <div className="b" style={{ height: deposits, background: "var(--sl-green)" }} />
            <div className="b" style={{ height: withdrawals, background: "#dc2626" }} />
            <div className="b" style={{ height: closing, background: "var(--sl-primary)" }} />
          </div>
          <div className={`ml-wf-net ${status}`}>{net}</div>
        </div>
      ))}
    </div>
  );

  const renderPane = () => {
    if (activeTour === "commitments") {
      return (
        <div className="ml-pane">
          <div className="ml-app-bar">
            <div className="ml-avatar">C</div>
            <div>
              <div className="ml-title">Detected Commitments</div>
              <div className="ml-name">Edit what counts toward DSR</div>
              <div className="ml-meta">Clustered by counterparty, amount pattern, and cadence</div>
            </div>
            <div className="ml-kpis">
              <div className="ml-kpi">Total kept<b>{formatSgd(commitmentTotal)}</b></div>
              <div className="ml-kpi">Lenders seen<b>3</b></div>
              <div className="ml-kpi">Live DSR<b className="good">{(commitmentTotal / adjustedRevenue * 100).toFixed(1)}%</b></div>
            </div>
            <span className="ml-live-pill">LIVE RECOMPUTE</span>
          </div>
          <div className="ml-card">
            <h3>Untick false positives and coverage ratios update live</h3>
            <p className="ml-sub">Recurring outflows are clustered by counterparty, amount pattern, and cadence.</p>
            <div className="ml-table-wrap">
              <table className="ml-tbl">
                <thead>
                  <tr>
                    <th>Keep</th>
                    <th>Counterparty</th>
                    <th>Cadence</th>
                    <th style={{ textAlign: "right" }}>Avg / mo</th>
                    <th>Months</th>
                    <th>Confidence</th>
                    <th>Tag</th>
                  </tr>
                </thead>
                <tbody>
                  {commitmentRows.map(([name, note, cadence, avg, months, confidence, tag], index) => (
                    <tr key={name}>
                      <td>
                        <button
                          type="button"
                          aria-label={`Toggle ${name}`}
                          className={`ml-chk ${keptCommitments[index] ? "on" : ""}`}
                          onClick={() => toggleCommitment(index)}
                        />
                      </td>
                      <td className="cp">{name}{note ? <div className="note">{note}</div> : null}</td>
                      <td>{cadence}</td>
                      <td className="amt">{formatSgd(avg)}</td>
                      <td>{months}</td>
                      <td><span className={`ml-conf ${confidence}`}>{confidence === "h" ? "High" : confidence === "m" ? "Medium" : "Low"}</span></td>
                      <td className="ml-tag-cell">{tag}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="ml-lump-foot">
              <span>Total monthly commitment kept. 3 likely lender(s) detected.</span>
              <span className="total">{formatSgd(commitmentTotal)}</span>
            </div>
          </div>
        </div>
      );
    }

    if (activeTour === "lumpSums") {
      const excluded = lumpSumRows.reduce((sum, row) => sum + (!row[6] ? row[1] : 0), 0);
      return (
        <div className="ml-pane">
          <div className="ml-app-bar">
            <div className="ml-avatar">C</div>
            <div>
              <div className="ml-title">Lump-sum Deposits Detected</div>
              <div className="ml-name">Decide what counts as revenue</div>
              <div className="ml-meta">Large or one-off credits flagged for review</div>
            </div>
            <div className="ml-kpis">
              <div className="ml-kpi">Excluded<b className="bad">{formatSgd(excluded)}</b></div>
              <div className="ml-kpi">Adjusted Revenue<b className="good">{formatSgd(adjustedRevenue)}</b></div>
            </div>
            <span className="ml-live-pill">AUTO-CLASSIFIED</span>
          </div>
          <div className="ml-card">
            <h3>Classifier separates recurring revenue from injections</h3>
            <p className="ml-sub">Review items that are not true operating income before the DSR denominator is finalized.</p>
            <div className="ml-table-wrap">
              <table className="ml-tbl">
                <thead>
                  <tr>
                    <th>Include?</th>
                    <th>Date</th>
                    <th style={{ textAlign: "right" }}>Amount</th>
                    <th>Description</th>
                    <th>Classification</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {lumpSumRows.map(([date, value, description, tone, label, reason, included]) => (
                    <tr key={`${date}-${description}`}>
                      <td><span className={`ml-chk ${included ? "on" : ""}`} /></td>
                      <td>{date}</td>
                      <td className="amt">{formatSgd(value)}</td>
                      <td className="cp">{description}</td>
                      <td><span className={`ml-class-badge ${tone}`}>{label}</span></td>
                      <td className="ml-tag-cell">{reason}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="ml-lump-foot">
              <span>Excluded lump sums: <b>{formatSgd(excluded)}</b></span>
              <span className="total">Adjusted revenue: <span style={{ color: "var(--sl-green)" }}>{formatSgd(adjustedRevenue)}</span></span>
            </div>
          </div>
        </div>
      );
    }

    if (activeTour === "evidence") {
      return (
        <div className="ml-pane">
          <div className="ml-app-bar">
            <div className="ml-avatar">C</div>
            <div>
              <div className="ml-title">Evidence & Drilldowns</div>
              <div className="ml-name">Strengths, concerns, risk flags and cash-flow narrative</div>
            </div>
            <div className="ml-kpis">
              <div className="ml-kpi">Avg recurring<b className="good">SGD 568,539</b></div>
              <div className="ml-kpi">Avg one-off<b>SGD 46,983</b></div>
            </div>
          </div>
          <div className="ml-triad">
            <div className="ml-tri-card strengths">
              <h5>Credit Strengths</h5>
              <ul>
                <li>Ending balances show usable liquidity buffer.</li>
                <li>No negative balance incidents detected.</li>
                <li>Zero bounced transaction descriptions.</li>
              </ul>
            </div>
            <div className="ml-tri-card concerns">
              <h5>Credit Concerns</h5>
              <ul>
                <li>Withdrawals consume most incoming deposits.</li>
                <li>Loan-related repayment wording appears frequently.</li>
                <li>Only 4 of 10 months ended net positive.</li>
              </ul>
            </div>
            <div className="ml-tri-card risk">
              <h5>Risk Flags</h5>
              <div className="ml-risk-box">
                <h6>SGD inflows are volatile <span>MEDIUM</span></h6>
                <p>Monthly deposits fluctuate noticeably, weakening repayment predictability.</p>
              </div>
            </div>
          </div>
          <div className="ml-card">
            <h3>Cash flow waterfall by month</h3>
            <p className="ml-sub">Opening, deposits, withdrawals, and closing balance are visible side by side.</p>
            {renderWaterfall()}
          </div>
        </div>
      );
    }

    if (activeTour === "exposure") {
      return (
        <div className="ml-pane">
          <div className="ml-app-bar">
            <div className="ml-avatar">C</div>
            <div>
              <div className="ml-title">Existing Lender Exposure</div>
              <div className="ml-name">Rolled up from kept commitments</div>
              <div className="ml-meta">3 likely lenders. SGD 1,028,244 estimated outstanding</div>
            </div>
          </div>
          <div className="ml-card">
            <h3>Existing lender exposure</h3>
            <p className="ml-sub">Loan repayment commitments roll up into counterparties with estimated outstanding balances.</p>
            <div className="ml-table-wrap">
              <table className="ml-tbl">
                <thead>
                  <tr>
                    <th>Lender / Counterparty</th>
                    <th style={{ textAlign: "right" }}>Monthly outflow</th>
                    <th style={{ textAlign: "center" }}>Months seen</th>
                    <th style={{ textAlign: "right" }}>Est. outstanding</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {exposureRows.map(([name, outflow, months, outstanding, note]) => (
                    <tr key={name}>
                      <td className="cp">{name}</td>
                      <td className="amt">{outflow}</td>
                      <td style={{ textAlign: "center" }}>{months}</td>
                      <td className="amt">{outstanding}</td>
                      <td className="ml-tag-cell">{note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="ml-stat-grid">
            <div className="ml-card ml-stat-card"><h4>Total monthly outflow</h4><div>SGD 46,738</div></div>
            <div className="ml-card ml-stat-card"><h4>Est. outstanding</h4><div>SGD 1,028,244</div></div>
            <div className="ml-card ml-stat-card"><h4>Lenders detected</h4><div>3</div></div>
          </div>
        </div>
      );
    }

    if (activeTour === "anomalies") {
      return (
        <div className="ml-pane">
          <div className="ml-app-bar">
            <div className="ml-avatar">C</div>
            <div>
              <div className="ml-title">Anomaly Feed</div>
              <div className="ml-name">Auto-flagged transactions for review</div>
              <div className="ml-meta">Lump credits, loan disbursements, and data-quality issues</div>
            </div>
          </div>
          <div className="ml-card">
            <h3>What SmartLend flagged for review</h3>
            <p className="ml-sub">Every anomaly is surfaced with a plain-English explanation.</p>
            {[
              ["Lump credit", "SGD 595,268 - DEC IBG GIRO OTHR Kris+ Pte Ltd", "Transfer or injection flagged before counting as operating revenue.", "Dec 8, 2025"],
              ["Lump credit", "SGD 400,000 - MAY LOAN TXN DISBURSEMENT", "Loan disbursement flagged before counting as revenue.", "May 22, 2025"],
              ["Data quality", "/03 - Date normalisation issue", "Re-parse if the statement will be used for final sign-off.", "Feb 1, 2026"],
            ].map(([tag, title, description, date]) => (
              <div className="ml-anom-row" key={title}>
                <span className="ml-anom-tag">{tag}</span>
                <div className="ml-anom-desc"><b>{title}</b><span>{description}</span></div>
                <div className="ml-anom-date">{date}</div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (activeTour === "monthly") {
      return (
        <div className="ml-pane">
          <div className="ml-app-bar">
            <div className="ml-avatar">C</div>
            <div>
              <div className="ml-title">Month-by-Month Detail - SGD</div>
              <div className="ml-name">Source data behind every ratio</div>
              <div className="ml-meta">10 months reviewed with deposits, withdrawals, net, end-balance, and lowest day.</div>
            </div>
          </div>
          <div className="ml-card">
            <div className="ml-table-wrap">
              <table className="ml-tbl">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th style={{ textAlign: "right" }}>Deposits</th>
                    <th style={{ textAlign: "right" }}>Withdrawals</th>
                    <th style={{ textAlign: "right" }}>Net</th>
                    <th style={{ textAlign: "right" }}>End balance</th>
                    <th style={{ textAlign: "right" }}>Lowest day</th>
                  </tr>
                </thead>
                <tbody>
                  {monthlyRows.map(([month, deposits, withdrawals, net, endBalance, lowest]) => (
                    <tr key={month}>
                      <td className="cp">{month}</td>
                      <td className="amt">{deposits}</td>
                      <td className="amt">{withdrawals}</td>
                      <td className="amt" style={{ color: net.startsWith("+") ? "var(--sl-green)" : "#dc2626" }}>{net}</td>
                      <td className="amt">{endBalance}</td>
                      <td className="amt">{lowest}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="ml-pane">
        <div className="ml-app-bar">
          <div className="ml-avatar">C</div>
          <div>
            <div className="ml-title">SmartLend - Lender View</div>
            <div className="ml-name">Carmen</div>
            <div className="ml-meta">SGD. 10 months. 2 account(s)</div>
          </div>
          <div className="ml-kpis">
            <div className="ml-kpi">Score<b>55/100</b></div>
            <div className="ml-kpi">DSR<b className="good">{liveDsr.toFixed(1)}%</b></div>
            <div className="ml-kpi">FCC<b className="good">{liveFcc.toFixed(2)}x</b></div>
            <div className="ml-kpi">Buffer<b>17.8d</b></div>
            <div className="ml-kpi">Bounces<b className="good">0</b></div>
          </div>
          <span className="ml-badge">Moderate</span>
        </div>
        <div className="ml-g3">
          <div className="ml-card">
            <h4>Credit Profile</h4>
            <div className="ml-gauge-wrap">
              <div className="ml-gauge"><div className="ml-gauge-val">55<small>/100</small></div></div>
              <div className="ml-chipcol">
                <span className="ml-chip amber">Repayment: Watchlist</span>
                <span className="ml-chip">Buffer: 17.8 days</span>
                <span className="ml-chip green">Bounces: 0</span>
                <span className="ml-chip red">Deposit volatility: 2.92x</span>
              </div>
            </div>
            <p className="ml-narrative">Overall profile is moderate: repayment capacity is watchlist, but the lending case has usable cash buffers and no bounced transactions.</p>
          </div>
          <div className="ml-card">
            <h4>Coverage Ratios <span className="ml-live-pill">LIVE</span></h4>
            <p className="ml-sub">Guideline reference: keep DSR within policy tolerance.</p>
            <div className="ml-ratio-row">
              <div className="ml-ratio-head">
                <div><div className="ml-ratio-label">DSR</div><div className="ml-ratio-sub">Commitments divided by adjusted revenue. Lower is better.</div></div>
                <div className="ml-ratio-val">{liveDsr.toFixed(1)}%<span className="tag">Strong</span></div>
              </div>
              <div className="ml-bar"><div className="ml-bar-needle" style={{ left: `${Math.min(liveDsr, 70)}%` }} /></div>
            </div>
            <div className="ml-ratio-row">
              <div className="ml-ratio-head">
                <div><div className="ml-ratio-label">FCC</div><div className="ml-ratio-sub">Average balance divided by monthly commitment. Higher is better.</div></div>
                <div className="ml-ratio-val">{liveFcc.toFixed(2)}x<span className="tag">Strong</span></div>
              </div>
              <div className="ml-bar reverse"><div className="ml-bar-needle" style={{ left: `${Math.min(liveFcc * 10, 88)}%` }} /></div>
            </div>
            <div className="ml-stress">
              <div className="ml-stress-title">Stress test a new facility</div>
              <div className="ml-slider-row">
                <div className="ml-slider-head"><span>Amount</span><b>{formatSgd(amount)}</b></div>
                <input className="ml-slider" type="range" min="0" max="800000" step="10000" value={amount} onChange={(event) => setAmount(Number(event.target.value))} />
              </div>
              <div className="ml-slider-row">
                <div className="ml-slider-head"><span>Tenor</span><b>{tenor} mo</b></div>
                <input className="ml-slider" type="range" min="6" max="60" step="1" value={tenor} onChange={(event) => setTenor(Number(event.target.value))} />
              </div>
              <div className="ml-slider-row">
                <div className="ml-slider-head"><span>Rate / mo</span><b>{rate.toFixed(1)}%</b></div>
                <input className="ml-slider" type="range" min="0.5" max="5" step="0.1" value={rate} onChange={(event) => setRate(Number(event.target.value))} />
              </div>
              <div className="ml-stress-result">
                Monthly payment = Principal / Tenor + Principal x Monthly rate<br />
                Principal: <b>{formatSgd(principal)}</b> &nbsp; Interest: <b>{formatSgd(interest)}</b> &nbsp; Total: <b>{formatSgd(totalPayment)}</b>
              </div>
            </div>
          </div>
          <div className="ml-card">
            <h4>Cash Position</h4>
            <div className="ml-cash-spark">
              <svg viewBox="0 0 300 70" preserveAspectRatio="none">
                <path d="M0,40 L25,45 L50,38 L75,42 L100,30 L125,48 L150,55 L175,35 L200,28 L225,32 L250,22 L275,20 L300,16 L300,70 L0,70 Z" fill="rgba(112,87,246,.16)" />
                <path d="M0,40 L25,45 L50,38 L75,42 L100,30 L125,48 L150,55 L175,35 L200,28 L225,32 L250,22 L275,20 L300,16" fill="none" stroke="#7057F6" strokeWidth="2" />
              </svg>
            </div>
            <div className="ml-cash-kv">
              <div><h5>Lowest day</h5><b className="red">SGD 556,998</b><span>Sep 30, 2025</span></div>
              <div><h5>Avg end-month</h5><b>SGD 1,347,208</b></div>
              <div><h5>Months net positive</h5><b>4/10</b></div>
              <div><h5>Deposit volatility</h5><b>2.92x</b></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="slSection ml-product-tour" id="partner-ml-tour">
      <div className="ml-tour-header">
        <span className="ml-section-tag">Interactive product tour</span>
        <h2>See every layer of our bank-statement parsing.</h2>
        <p>
          Click through the same lender-facing analysis flow from the ML Analysis page.
          Ratios recompute live as users adjust commitments, lump sums, and facility assumptions.
        </p>
      </div>

      <div className="ml-tour-tabs">
        {tourTabs.map(([id, label]) => (
          <button
            key={id}
            type="button"
            className={`ml-tour-tab ${activeTour === id ? "active" : ""}`}
            onClick={() => setActiveTour(id)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="ml-window">
        <div className="ml-window-chrome">
          <span className="ml-chrome-dot r" />
          <span className="ml-chrome-dot y" />
          <span className="ml-chrome-dot g" />
          <div className="ml-chrome-url">app.smartlend.io/cases/<b>carmen-2026-q1</b></div>
          <span className="ml-live-pill">LIVE</span>
        </div>
        {renderPane()}
      </div>
    </section>
  );
};

const PartnerWithUs = () => {
  const history = useHistory();
  const [createLenderModal, setCreateLenderModal] = useState(false);
  const [sendingNotification, setSendingNotification] = useState(false);
  const [lenderDetails, setLenderDetails] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
  });
  const [lenderFormErrors, setLenderFormErrors] = useState({});

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());

  const resetLenderForm = () => {
    setLenderDetails({
      first_name: "",
      last_name: "",
      email_address: "",
      phone_number: "",
    });
    setLenderFormErrors({});
  };

  const closeCreateLenderModal = () => {
    setCreateLenderModal(false);
    setSendingNotification(false);
    resetLenderForm();
  };

  const handleLenderDetailsChange = (field, value) => {
    setLenderDetails((prev) => ({ ...prev, [field]: value }));
    setLenderFormErrors((prev) => {
      if (!prev[field]) return prev;
      const nextErrors = { ...prev };
      delete nextErrors[field];
      return nextErrors;
    });
  };

  const sendPartnerInterest = async () => {
    const trimmedDetails = {
      first_name: lenderDetails.first_name.trim(),
      last_name: lenderDetails.last_name.trim(),
      email_address: lenderDetails.email_address.trim(),
      phone_number: lenderDetails.phone_number.trim(),
    };
    const errors = {};
    if (!trimmedDetails.first_name) errors.first_name = "First name is required.";
    if (!trimmedDetails.last_name) errors.last_name = "Last name is required.";
    if (!trimmedDetails.phone_number) errors.phone_number = "Phone number is required.";
    if (!trimmedDetails.email_address) errors.email_address = "Email address is required.";
    else if (!validateEmail(trimmedDetails.email_address)) {
      errors.email_address = "Please enter a valid email address.";
    }
    if (Object.keys(errors).length) {
      setLenderFormErrors(errors);
      message.error("Please complete all required fields.");
      return;
    }

    setSendingNotification(true);
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/smartlend/lenderCreateEmail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(trimmedDetails),
        },
      );
      const json = await response.json();
      if (response.ok) {
        message.success(json?.message || "Thanks, we will contact you soon.");
        closeCreateLenderModal();
      } else {
        message.error(json?.message || "We could not submit your interest right now.");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong while submitting your details.");
    } finally {
      setSendingNotification(false);
    }
  };

  return (
    <div className="slMarketingPage">
      <HomeHeader />

      <Modal
        open={createLenderModal}
        onCancel={closeCreateLenderModal}
        footer={null}
        centered
        destroyOnClose
        width={680}
        styles={{ content: { padding: 0, borderRadius: 24, overflow: "hidden" }, body: { padding: 0 } }}
      >
        <div style={{ background: "linear-gradient(135deg,#7057F6,#8B6CFF)", color: "#fff", padding: "34px" }}>
          <div className="slEyebrow" style={{ color: "#7057F6" }}>
            <span className="slEyebrowDot" />Partner with SmartLend
          </div>
          <h2 style={{ margin: 0, color: "#fff", fontSize: 34, lineHeight: 1.08, fontWeight: 900 }}>
            Tell us about your interest and we will reach out.
          </h2>
          <p style={{ marginTop: 12, color: "rgba(255,255,255,.9)", lineHeight: 1.6 }}>
            Share your contact details and our team will discuss partnership opportunities,
            onboarding, and API-powered lending support.
          </p>
        </div>
        <div style={{ padding: 30, background: "linear-gradient(180deg,#F7F8FE,#fff)" }}>
          <div className="slFormGrid slGrid2">
            {[
              ["first_name", "First name", "Enter your first name", "text"],
              ["last_name", "Last name", "Enter your last name", "text"],
              ["phone_number", "Phone number", "Enter your phone number", "tel"],
              ["email_address", "Email address", "Enter your email address", "email"],
            ].map(([key, label, placeholder, type]) => (
              <div className="slField" key={key}>
                <label>{label}</label>
                <input
                  type={type}
                  value={lenderDetails[key]}
                  placeholder={placeholder}
                  onChange={(event) => handleLenderDetailsChange(key, event.target.value)}
                  style={{ borderColor: lenderFormErrors[key] ? "#DC2626" : undefined }}
                />
                {lenderFormErrors[key] ? (
                  <span style={{ color: "#DC2626", fontSize: 12 }}>{lenderFormErrors[key]}</span>
                ) : null}
              </div>
            ))}
          </div>
          <div className="slCard slCardSoft" style={{ marginTop: 18 }}>
            <p>Your details will only be used for partnership follow-up by the SmartLend team.</p>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 22 }}>
            <Button onClick={closeCreateLenderModal} className="slBtn">Cancel</Button>
            <Button loading={sendingNotification} onClick={sendPartnerInterest} className="slBtn slBtnPrimary">
              Submit interest
            </Button>
          </div>
        </div>
      </Modal>

      <main className="slMarketingShell">
        <div className="slMarketingFrame">
          <section className="slMarketingHero">
            <div className="slMarketingHeroCopy">
              <div className="slEyebrow"><span className="slEyebrowDot" />Lender partnership</div>
              <h1>Grow lending volume with cleaner borrower intelligence.</h1>
              <p className="slLead">
                SmartLend gives financing partners a sharper way to discover, assess,
                message, and fund SME borrowers through one consistent platform experience.
              </p>
              <div className="slActions">
                <button className="slBtn slBtnPrimary" type="button" onClick={() => setCreateLenderModal(true)}>
                  Become a partner
                </button>
                <button className="slBtn" type="button" onClick={() => history.push("/ml-analysis")}>
                  View lender workflow
                </button>
              </div>
              <div className="slMetricRow">
                <div className="slMetric"><span>Use case</span><b>SME loans</b></div>
                <div className="slMetric"><span>Review flow</span><b>Digital</b></div>
                <div className="slMetric"><span>Visibility</span><b>Live</b></div>
              </div>
            </div>
            <div className="slMarketingMedia">
              <img src={Macbook} alt="SmartLend lender dashboard preview" />
              <div className="slMediaCaption">
                <b>One partner view</b>
                <p>Loan requests, borrower documents, analytics, messages, and offer decisions stay in one place.</p>
              </div>
            </div>
          </section>

          <section className="slSection">
            <div className="slSectionHead">
              <div>
                <h2>Why lending partners use SmartLend</h2>
                <p>Designed around the practical work of reviewing borrowers and maintaining portfolio discipline.</p>
              </div>
            </div>
            <div className="slGrid slGrid3">
              {benefitCards.map((item) => (
                <article className="slCard" key={item.title}>
                  <div className={`slIcon ${item.tone === "pink" ? "slIconPink" : item.tone === "green" ? "slIconGreen" : ""}`}>{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="slSection">
            <div className="slGrid slGrid3">
              <article className="slCard">
                <div className="slSignalGraphic"><div className="slBolt">⚡</div></div>
                <h3>Faster operating rhythm</h3>
                <p>Move from borrower intake to lender review and offer follow-up with fewer manual handoffs.</p>
              </article>
              <article className="slCard">
                <div className="slSignalGraphic"><div className="slPortfolioBars"><span>C</span><span>M</span><span>P</span></div></div>
                <h3>Diversified loan portfolio</h3>
                <p>Keep corporate, money lender, and property term loan opportunities clearly separated.</p>
              </article>
              <article className="slCard">
                <div className="slSignalGraphic"><div className="slRadar" /></div>
                <h3>Transparency and insights</h3>
                <p>Surface activity, bank statement signals, and offer history so partner teams can act with context.</p>
              </article>
            </div>
          </section>

          <section className="slSection">
            <div className="slSectionHead">
              <div>
                <h2>API-powered lending, with partner controls intact</h2>
                <p>Connect borrower intake, status updates, and decision workflows into existing lender systems.</p>
              </div>
              <button className="slBtn slBtnPrimary" type="button" onClick={() => setCreateLenderModal(true)}>
                Explore API access
              </button>
            </div>
            <div className="slGrid slGrid2">
              <article className="slCard slCardSoft">
                <div className="slIcon">API</div>
                <h3>Connect lending workflows</h3>
                <p>Sync borrower requests, offer statuses, repayment milestones, and document updates into internal CRM or underwriting tools.</p>
                <div className="slMetricRow">
                  <div className="slMetric"><span>Access</span><b>API</b></div>
                  <div className="slMetric"><span>Flow</span><b>Live</b></div>
                  <div className="slMetric"><span>Use</span><b>Lender</b></div>
                </div>
              </article>
              <article className="slCard">
                <div className="slGrid">
                  {partnerPoints.map((point) => (
                    <div className="slCard" key={point.title}>
                      <div className={`slIcon ${point.tone === "pink" ? "slIconPink" : point.tone === "green" ? "slIconGreen" : ""}`}>{point.icon}</div>
                      <h3>{point.title}</h3>
                      <p>{point.description}</p>
                    </div>
                  ))}
                </div>
              </article>
            </div>
          </section>

          <MlAnalysisTour />

          <section className="slSection slCard slCardSoft">
            <div className="slSectionHead">
              <div>
                <h2>Partner onboarding flow</h2>
                <p>A simple operating rhythm from account setup to borrower offer management.</p>
              </div>
              <button className="slBtn slBtnPrimary" type="button" onClick={() => setCreateLenderModal(true)}>
                Start onboarding
              </button>
            </div>
            <div className="slGrid slGrid4">
              {workflow.map(([step, title, description]) => (
                <article className="slCard" key={title}>
                  <div className="slIcon">{step}</div>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </article>
              ))}
            </div>
          </section>
        </div>
      </main>

      <NewHomepageFooter />
    </div>
  );
};

export default PartnerWithUs;
